module.exports = __webpack_public_path__ + "img/image 006.704ccbfc.png";